var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bodyText"},[_c('div',{staticClass:"btnsBos"},[_c('p',{staticClass:"start-button",on:{"click":_vm.getBackt}},[_vm._v(" 确认")])]),_c('div',{staticClass:"textbox",attrs:{"id":"textbox"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }